var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect } from "react";
import { DatagridConfigurable, List, TextField, TextInput, WrapperField, FunctionField, useRefresh, useNotify, useGetList, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Button, Chip, Tooltip, Typography } from "@mui/material";
import { Dialog } from "@sequentech/ui-essentials";
import { ActionsColumn } from "../../components/ActionButons";
import { useTranslation } from "react-i18next";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { WizardSteps } from "./TallySheetWizard";
import { useMutation } from "@apollo/client";
import { REVIEW_TALLY_SHEET } from "@/queries/reviewTallySheet";
import { ContestItem } from "@/components/ContestItem";
import { AreaItem } from "@/components/AreaItem";
import { Add, WorkHistory } from "@mui/icons-material";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
import { AuthContext } from "@/providers/AuthContextProvider";
import { EStatus } from "@/types/TallySheets";
import { ListTallySheetVersions } from "./ListTallySheetVersions";
var OMIT_FIELDS = ["id"];
var Filters = [
    _jsx(TextInput, { label: "Area", source: "area_id" }, 0),
    _jsx(TextInput, { label: "Contest", source: "contest_id" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(TextInput, { label: "Channel", source: "channel" }, 3),
    _jsx(TextInput, { label: "Latest version", source: "version" }, 4),
    _jsx(TextInput, { label: "Labels", source: "labels" }, 5),
    _jsx(TextInput, { label: "Annotations", source: "annotations" }, 6),
];
export var ListTallySheet = function (props) {
    var election = props.election, doAction = props.doAction, reload = props.reload;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var refresh = useRefresh();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var notify = useNotify();
    var _a = React.useState(false), showVersionsTable = _a[0], setShowVersionsTable = _a[1];
    var _b = React.useState(undefined), selectedTallySheet = _b[0], setSelectedTallySheet = _b[1];
    var _c = React.useState(false), openDisapproveDialog = _c[0], setOpenDisapproveDialog = _c[1];
    var _d = React.useState(false), openApproveDialog = _d[0], setOpenApproveDialog = _d[1];
    var _e = React.useState(), tallySheetId = _e[0], setTallySheetId = _e[1];
    var reviewTallySheet = useMutation(REVIEW_TALLY_SHEET, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.TALLY_SHEET_REVIEW,
            },
        },
    })[0];
    var authContext = useContext(AuthContext);
    var canCreate = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_CREATE);
    var canView = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_VIEW);
    var canReview = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_REVIEW);
    var sheetsDescVersions = useGetList("sequent_backend_tally_sheet", {
        filter: {
            tenant_id: tenantId,
            election_event_id: election.election_event_id,
            election_id: election.id,
            deleted_at: {
                format: "hasura-raw-query",
                value: { _is_null: true },
            },
        },
        pagination: {
            page: 1,
            perPage: 100,
        },
        sort: {
            field: "version",
            order: "DESC",
        },
    }).data;
    var getLatestVersion = function (area_id, contest_id, channel) {
        var _a;
        var approvedVersion = sheetsDescVersions === null || sheetsDescVersions === void 0 ? void 0 : sheetsDescVersions.find(function (sheet) {
            return sheet.area_id === area_id &&
                sheet.contest_id === contest_id &&
                sheet.channel === channel;
        });
        return (_a = approvedVersion === null || approvedVersion === void 0 ? void 0 : approvedVersion.version) !== null && _a !== void 0 ? _a : "-";
    };
    var getLatestApprovedVersion = function (area_id, contest_id, channel) {
        var _a;
        var approvedVersion = sheetsDescVersions === null || sheetsDescVersions === void 0 ? void 0 : sheetsDescVersions.find(function (sheet) {
            return sheet.area_id === area_id &&
                sheet.contest_id === contest_id &&
                sheet.channel === channel &&
                sheet.status === EStatus.APPROVED;
        });
        return (_a = approvedVersion === null || approvedVersion === void 0 ? void 0 : approvedVersion.version) !== null && _a !== void 0 ? _a : "-";
    };
    useEffect(function () {
        localStorage.removeItem("tallySheetData");
    }, []);
    useEffect(function () {
        if (reload) {
            refresh();
        }
    }, [reload, refresh]);
    var createAction = function () {
        localStorage.removeItem("tallySheetData");
        doAction(WizardSteps.Start);
    };
    var addAction = function (id) {
        localStorage.removeItem("tallySheetData");
        var selected = sheetsDescVersions === null || sheetsDescVersions === void 0 ? void 0 : sheetsDescVersions.find(function (s) {
            return s.id === id;
        });
        var latestVersion = sheetsDescVersions === null || sheetsDescVersions === void 0 ? void 0 : sheetsDescVersions.find(function (s) {
            return (s.area_id === (selected === null || selected === void 0 ? void 0 : selected.area_id) &&
                s.contest_id === (selected === null || selected === void 0 ? void 0 : selected.contest_id) &&
                s.channel === (selected === null || selected === void 0 ? void 0 : selected.channel));
        });
        doAction(WizardSteps.Edit, latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.id);
    };
    var versionsTableAction = function (id) {
        setShowVersionsTable(true);
        setTallySheetId(id);
        setSelectedTallySheet(sheetsDescVersions === null || sheetsDescVersions === void 0 ? void 0 : sheetsDescVersions.find(function (s) { return s.id === id; }));
    };
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("tallysheet.empty.header") }), canCreate && (_jsxs(_Fragment, { children: [_jsxs(Button, { onClick: createAction, children: [_jsx(Add, {}), t("tallysheet.empty.action")] }), _jsx(Typography, { variant: "body1", paragraph: true, children: t("common.resources.noResult.askCreate") })] }))] })); };
    if (!canView) {
        return _jsx(Empty, {});
    }
    var viewAction = function (id) {
        doAction(WizardSteps.View, id);
    };
    var approveAction = function (id) {
        setTallySheetId(id);
        setOpenApproveDialog(true);
    };
    var disapproveAction = function (id) {
        setTallySheetId(id);
        setOpenDisapproveDialog(true);
    };
    var confirmReviewAction = function (newStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, reviewTallySheet({
                        variables: {
                            electionEventId: election.election_event_id,
                            tallySheetId: tallySheetId,
                            newStatus: newStatus,
                        },
                    })
                    // if (data && !data?.publish_tally_sheet?.tally_sheet_id) {
                    //     console.log("(unpublished) tally sheet not found, probably it's already published")
                    // }
                ];
                case 1:
                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                    // if (data && !data?.publish_tally_sheet?.tally_sheet_id) {
                    //     console.log("(unpublished) tally sheet not found, probably it's already published")
                    // }
                    if (errors) {
                        // add error notification
                        notify(t("tallysheet.message.reviewError"), { type: "error" });
                    }
                    else {
                        notify(t("tallysheet.message.reviewSuccess"), { type: "success" });
                    }
                    setTallySheetId(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    var actions = function (record) { return [
        {
            icon: (_jsx(Tooltip, { title: String(t("tallysheet.common.add")), children: _jsx(Add, {}) })),
            action: addAction,
            showAction: function () { return canCreate; },
            label: String(t("tallysheet.common.add")),
        },
        {
            icon: (_jsx(Tooltip, { title: String(t("tallysheet.common.versions")), children: _jsx(WorkHistory, {}) })),
            action: versionsTableAction,
            showAction: function () { return canView; },
            label: String(t("tallysheet.common.versions")),
        },
    ]; };
    return (_jsxs(_Fragment, { children: [showVersionsTable && selectedTallySheet && (_jsx(ListTallySheetVersions, { tallySheet: selectedTallySheet, approveAction: approveAction, disapproveAction: disapproveAction, doAction: doAction, reload: reload, setShowVersionsTable: setShowVersionsTable })), !showVersionsTable && (_jsx(List, { disableSyncWithLocation: true, queryOptions: {
                    refetchInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
                    meta: { distinctBallotBoxes: true },
                }, resource: "sequent_backend_tally_sheet", actions: _jsx(ListActions, { withImport: false, withExport: false, extraActions: [
                        _jsxs(Button, { onClick: createAction, children: [_jsx(Add, {}), t("tallysheet.empty.add")] }, 0),
                    ] }), sx: { flexGrow: 2 }, filter: {
                    tenant_id: election.tenant_id || undefined,
                    election_event_id: election.election_event_id || undefined,
                    election_id: election.id || undefined,
                    deleted_at: {
                        format: "hasura-raw-query",
                        value: { _is_null: true },
                    },
                }, filters: Filters, empty: _jsx(Empty, {}), children: _jsxs(DatagridConfigurable, { bulkActionButtons: false, omit: OMIT_FIELDS, sx: {
                        flexGrow: 1,
                        overflowX: "auto",
                        width: "100%",
                        maxWidth: "100%",
                    }, children: [_jsx(TextField, { source: "id", sortable: false }), _jsx(FunctionField, { source: "channel", sortable: false, label: String(t("tallysheet.label.channel")), render: function (record) { return (_jsx(Chip, { label: record.channel })); } }), _jsx(FunctionField, { label: String(t("tallysheet.table.contest")), render: function (record) { return (_jsx(ContestItem, { record: record.contest_id })); } }), _jsx(FunctionField, { label: String(t("tallysheet.table.area")), render: function (record) { return (_jsx(AreaItem, { record: record.area_id })); } }), _jsx(FunctionField, { label: String(t("tallysheet.table.latestVersion")), render: function (record) {
                                return getLatestVersion(record.area_id, record.contest_id, record.channel);
                            } }), _jsx(FunctionField, { label: String(t("tallysheet.table.approvedVersion")), render: function (record) {
                                return getLatestApprovedVersion(record.area_id, record.contest_id, record.channel);
                            } }), _jsx(FunctionField, { source: "labels", label: String(t("tallysheet.table.labels")), render: function (record) {
                                return formatJsonValue(record.labels);
                            } }), _jsx(FunctionField, { source: "annotations", label: String(t("tallysheet.table.annotations")), render: function (record) {
                                return formatJsonValue(record.annotations);
                            } }), _jsx(WrapperField, { source: "actions", label: "Actions", children: _jsx(FunctionField, { label: String(t("tallysheet.table.area")), render: function (record) { return (_jsx(ActionsColumn, { actions: actions(record) })); } }) })] }) })), _jsx(Dialog, { variant: "warning", open: openDisapproveDialog, ok: String(t("tallysheet.common.disapprove")), cancel: String(t("common.label.cancel")), title: String(t("tallysheet.common.disapprove")), handleClose: function (result) {
                    if (result) {
                        confirmReviewAction(EStatus.DISAPPROVED);
                    }
                    setOpenDisapproveDialog(false);
                }, children: t("tallysheet.common.warningDisapprove") }), _jsx(Dialog, { variant: "info", open: openApproveDialog, ok: String(t("tallysheet.common.approve")), cancel: String(t("common.label.cancel")), title: String(t("tallysheet.common.approve")), handleClose: function (result) {
                    if (result) {
                        confirmReviewAction(EStatus.APPROVED);
                    }
                    setOpenApproveDialog(false);
                }, children: t("tallysheet.common.warningApprove") })] }));
};
var formatJsonValue = function (value) {
    if (value === null || value === undefined || value === "") {
        return "-";
    }
    if (typeof value === "string") {
        return value;
    }
    try {
        return JSON.stringify(value);
    }
    catch (_error) {
        return String(value);
    }
};
